// extracted by mini-css-extract-plugin
module.exports = {"root":"TnEVI","button":"qAM5G","text":"eIp6p","buttonDesktop":"LP2aL","buttonHidden":"_2AwEC","buttonMobile":"_5JOFv"};